// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".landing-promo-carousel[data-v-2611cf90]{overflow:hidden;padding-bottom:64px}@media (min-width:775px){.landing-promo-carousel[data-v-2611cf90]{padding-bottom:24px}}@media (min-width:1904px){.landing-promo-carousel[data-v-2611cf90]{max-width:2400px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
